import React from "react";
import { Table } from "react-bootstrap";
import NoDataFound from "../../../../components/NoDataFound";
import { FaFolderOpen } from "react-icons/fa";

const ProjectTable = ({ projects, columns }) => {
  return (
    <>
      {projects.length > 0 ? (
        <Table responsive>
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col.accessor}
                  onClick={() => col.sortable && col.handleSort?.(col.sortKey)}
                  style={{ cursor: col.sortable ? "pointer" : "default" }}
                >
                  {col.header}{" "}
                  {/* {col.sortBy === col.sortKey &&
                (col.sortOrder === "asc" ? "↑" : "↓")} */}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {projects?.map((project) => (
              <tr key={project._id}>
                {columns.map((col) => (
                  <td key={col.accessor}>
                    {col.cell ? col.cell(project) : project[col.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <NoDataFound
          icon={<FaFolderOpen size={50} />}
          title="Projects not found"
          description="Try to add some projects."
        />
      )}
    </>
  );
};
export default ProjectTable;
